import { useQuery } from "@tanstack/react-query";
import { filter } from "lodash";

import { useUser } from "../contexts/user";
import { QUERY_KEYS } from "../constants";
import api from "../api";

const client = api();

export default function useFavoritesQuery(predicate, options = {}) {
  const { user } = useUser();

  const {
    data: favorites,
    isLoading: isFavoritesLoading,
    isError: favoritesError,
  } = useQuery([QUERY_KEYS.FAVORITES], client.getFavorites, {
    enabled: user.isLoggedIn,
    select: (data) => filter(data, predicate),
    staleTime: Infinity,
    ...options,
  });

  return { favorites, isFavoritesLoading, favoritesError };
}
